// @ts-nocheck Porting this over
import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { computed } from 'zustand-computed'

const DURATION = 500

interface State {
  isRunning: boolean
  startTime: number
  endTime: number
  start: () => void
  pause: () => void
  reset: () => void
  stop: () => void
}

interface ComputedState {
  milliseconds: number
}

const computedState = (state: State): ComputedState => {
  return {
    milliseconds: state.endTime - state.startTime,
  }
}

export const useRestTimer = create<State>()(
  persist(
    computed((set) => {
      let interval: undefined | unknown

      function pause() {
        if (interval) {
          set({
            isRunning: false,
            endTime: Date.now(),
          })
          clearInterval(interval)
        }
      }
      function start() {
        clearInterval(interval)
        set((state) => {
          const now = Date.now()
          const isRestarting = state.endTime && now > state.endTime
          const startTime = isRestarting
            ? now - (state.endTime - state.startTime)
            : now
          const endTime = isRestarting ? now : state.endTime
          return {
            isRunning: true,
            startTime,
            endTime,
          }
        })
        interval = setInterval(() => {
          set((state) => ({
            startTime: state.startTime,
            endTime: Date.now(),
          }))
        }, DURATION)
      }

      function reset() {
        set({
          startTime: 0,
          endTime: -1,
        })
      }

      function stop() {
        if (interval) {
          clearInterval(interval)
        }
        set({
          startTime: 0,
          endTime: -1,
          isRunning: false,
        })
      }

      return {
        pause,
        start,
        reset,
        stop,
        isRunning: false,
        endTime: 0,
        startTime: 0,
      }
    }, computedState),
    {
      name: 'rest_timer',
      version: 1,
      onRehydrateStorage: () => {
        return (state, _err) => {
          if (state?.isRunning) {
            state.start()
          }
        }
      },
    }
  )
)
